module.exports = __webpack_public_path__ + "static/media/iconfinder_mobile_1287520.3e4debb1.svg";